<template>
  <el-tree-select ref="treeSelect"
                  class="border"
                  :model-value="resolvedValue"
                  @update:model-value="updateCategory"
                  :data="categoryTree"
                  :props="{ value: 'id', label: 'label', children: 'children' }"
                  node-key="id"
                  check-strictly
                  placeholder="카테고리 선택"
  />
</template>

<script>
  import axios from "../axiosConfig";

  function category(categories){
    if(typeof categories ==='undefined') return []

    return categories.map(cat => {
      let returnValue = {
        id: cat.ca_id,
        label: cat.ca_name
      }
      let children = category(cat.children)
      if(children.length > 0){
        returnValue.children = children
      }
      return returnValue
    })
  }

  /**
   * 카테고리 셀렉터
   * Component: Element Plus TreeSelect
   */
  export default {
    name: "categorySelector",
    props: {
      value: {default: undefined},
      modelValue: {default: undefined},
    },
    emits: ['input', 'selected', 'update:modelValue', 'update:value'],
    data(){
      return {
        // categorySelected: null,
        categories: []
      }
    },
    computed: {
      resolvedValue() {
        return this.modelValue !== undefined ? this.modelValue : this.value;
      },
      categoryTree(){
        return category(this.categories)
      }
    },
    methods: {
      updateCategory(value){
        this.$emit('input', value)
        this.$emit('selected', value)
        this.$emit('update:modelValue', value)
        this.$emit('update:value', value)
      }
    },
    created() {
      axios.get('/api/v1/category-simple')
        .then(res => {
          this.categories = res.data.data
        })
    },
    mounted() {
      this.updateCategory(this.resolvedValue)
    }
    // watch: {
    //   categorySelected(selected){
    //
    //     if(selected === null){
    //       this.$refs.treeSelect.value = null
    //     } else {
    //       this.$emit('selected', selected)
    //     }
    //   }
    // }
  }
</script>

<style>
  .vue-treeselect__control{
    border: none;
  }
</style>
